module.exports = __webpack_public_path__ + "fonts/Finch-Frame-2-Bold.0579a207.ttf";